// Module
var code = "<div class=\"ToolBarPreview\"> <label> <i class=\"glyphicon glyphicon-time\" aria-hidden=\"true\"></i> <!-- ko text: GetControlTypeTranslatedName() --><!-- /ko --> </label> </div>";
// Exports
export default code;